
const CaseStudies = () => {
    return (
        <>
            <div className='flex flex-col items-center px-4 sm:px-12 py-14 sm:pt-32 xl:pt-36 bg-gradient-to-b from-[#CACDE5] to-[#FFFFFF]'>
                <h1 className='text-[var(--kaizekblue)] font-uiBold text-4xl xl:text-5xl'>Case Studies</h1>
                <p className='text-[var(--lightgray)] font-symbol text-xl lg:text-2xl text-center my-4'>
                Real-world implementations and success stories</p>
                <div className='grid lg:grid-cols-3  gap-6 sm:gap-4 xl:gap-8 pt-8 lg:pt-16 2xl:w-9/12 mx-4 xl:mx-0'>
                    <div className='rounded-3xl bg-smartCity bg-cover bg-no-repeat border-b-[0.625rem] border-[var(--coolgray)] overflow-hidden'>
                        <div className="bg-[#000000aa] p-8 rounded-2xl">
                            <h3 className="text-white font-uiBold text-base lg:text-[1.75rem] leading-8">
                            SMART CITY</h3>
                            <h2 className="text-white font-uiSemilight text-2xl xl:text-3xl my-4 lg:my-8">Metropolitan Lighting Control</h2>
                            <p className="text-[var(--whitetext)] font-symbol text-base lg:text-xl my-4 lg:my-6">Implementation of smart lighting system for a major metropolitan area</p>
                            <ul className="text-[var(--whitetext)] font-symbol text-base lg:text-xl ms-2 list-disc list-outside xl:list-inside leading-8 my-4">
                                <li>50,000+ connected devices</li>
                                <li>60% energy savings</li>
                                <li>Reduced maintenance costs</li>
                            </ul>
                        </div>
                    </div>
                    <div className='rounded-3xl bg-industrialIot bg-cover bg-no-repeat border-b-[0.625rem] border-[var(--coolgray)] overflow-hidden'>
                        <div className="bg-[#000000aa] p-8 rounded-2xl">
                            <h3 className="text-white font-uiBold text-base lg:text-[1.75rem] leading-8">
                            INDUSTRIAL IoT</h3>
                            <h2 className="text-white font-uiSemilight text-2xl xl:text-3xl my-4 lg:my-8 sm:w-9/12 lg:w-8/12">Factory Automation</h2>
                            <p className="text-[var(--whitetext)] font-symbol text-base lg:text-xl my-4 lg:my-6">Smart factory implementation with complete IoT integration</p>
                            <ul className="text-[var(--whitetext)] font-symbol text-base lg:text-xl ms-2 list-disc list-outside xl:list-inside leading-8 my-4">
                                <li>Real-time monitoring</li>
                                <li>Predictive maintenance</li>
                                <li>40% efficiency increasen</li>
                            </ul>
                        </div>
                    </div>
                    <div className='rounded-3xl bg-smartAgriculture bg-cover bg-no-repeat border-b-[0.625rem] border-[var(--coolgray)] overflow-hidden'>
                        <div className="bg-[#000000aa] p-8 rounded-2xl">
                            <h3 className="text-white font-uiBold text-base lg:text-[1.75rem] leading-8">
                            SMART AGRICULTURE</h3>
                            <h2 className="text-white font-uiSemilight text-2xl xl:text-3xl my-4 lg:my-8 lg:w-7/12">Precision Farming</h2>
                            <p className="text-[var(--whitetext)] font-symbol text-base lg:text-xl my-4 lg:my-6 lg:w-10/12">IoT-based precision agriculture system implementation</p>
                            <ul className="text-[var(--whitetext)] font-symbol text-base lg:text-xl ms-2 list-disc list-outside xl:list-inside leading-8 my-4">
                                <li>Environmental monitoring</li>
                                <li>Automated irrigation</li>
                                <li>30% water savings</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="mt-10 lg:mt-12 xl:mt-20">
                    <button className="button-theme">
                    Start a project
                    </button>
                </div>

            </div>
        </>
    )
}

export default CaseStudies